import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {WebSocketProvider} from './context/WebSocketProvider';
import UserProvider from './context/UserProvider';
import NotificationProvider from './context/NotificationProvider';
import VendorProvider from './context/VendorProvider';
import WebsiteProvider from './context/WebsiteProvider';
import VendorFileProvider from './context/VendorFileProvider';
import WebsiteFileProvider from './context/WebsiteFileProvider';
import ContactProvider from './context/ContactProvider';
import SettingsProvider from './context/SettingsProvider';
import ModalProvider from './context/ModalProvider';
import AccountsProvider from './context/AccountsProvider';
import {AccessibilityProvider} from "./context/AccessibilityProvider";

const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("validateDOMNesting")
  ) {
    return; // Ignore validateDOMNesting warnings
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <UserProvider>
      <AccessibilityProvider>
        <SettingsProvider>
          <AccountsProvider>
            <ModalProvider>
              <NotificationProvider>
                <VendorProvider>
                  <WebsiteProvider>
                    <WebsiteFileProvider>
                      <VendorFileProvider>
                        <ContactProvider>
                          <WebSocketProvider>
                            <App/>
                          </WebSocketProvider>
                        </ContactProvider>
                      </VendorFileProvider>
                    </WebsiteFileProvider>
                  </WebsiteProvider>
                </VendorProvider>
              </NotificationProvider>
            </ModalProvider>
          </AccountsProvider>
        </SettingsProvider>
      </AccessibilityProvider>
    </UserProvider>
  </BrowserRouter>
);

reportWebVitals();
